// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@a-type/ui';
import { appsById, isValidAppId } from '@biscuits/apps';
import { Suspense, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { installState } from '../install.js';
import { InstallButton } from './InstallButton.js';
export function AppPreviewNotice({}) {
    const searchParams = new URLSearchParams(window.location.search);
    const appPickerFrom = searchParams.get('appPickerFrom');
    const { installReady } = useSnapshot(installState);
    useEffect(() => {
        // consume the param if present
        if (appPickerFrom) {
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.delete('appPickerFrom');
            const url = new URL(window.location.href);
            url.search = searchParams.toString();
            window.history.replaceState(null, '', url.toString());
        }
    }, [appPickerFrom]);
    if (!appPickerFrom)
        return null;
    // if we can't install this as a PWA, there's not much point in showing this warning
    if (!installReady) {
        return null;
    }
    if (!isValidAppId(appPickerFrom))
        return null;
    const fromApp = appsById[appPickerFrom];
    // this app is probably rendered inside a frame in the other app
    return (_jsxs("div", { className: "w-full bg-accent-light p-2 flex flex-row gap-3 items-center", children: [_jsx("p", { className: "text-sm color-accent-dark flex-1", children: `You're previewing this app.` }), _jsx(Button, { asChild: true, children: _jsx("a", { href: fromApp.url, target: "_blank", rel: "noopener noreferrer", children: `Back to ${fromApp.name}` }) }), _jsx(Suspense, { children: _jsx(InstallButton, {}) })] }));
}
//# sourceMappingURL=AppPreviewNotice.js.map